export function resolveInvokeEventSelectedData(data: unknown): unknown {
  if (data == null) return undefined
  if (
    typeof data === 'object' &&
    typeof (data as { getField?: unknown }).getField === 'function' &&
    typeof (data as { hasField?: unknown }).hasField === 'function'
  ) {
    return undefined
  }
  const d = data as { selectedData?: unknown; selected?: unknown }
  return d.selectedData ?? d.selected ?? data
}

/**
 * `invokeEvent(..., en.getData())` passes a live UniData. Nested runCode then
 * overlays the page snapshot onto the same object, so copy fields first.
 */
export function coerceInvokeEventSelectedData(data: unknown): unknown {
  const snapshotUniData = (value: unknown): { fields: Record<string, unknown> } | undefined => {
    if (
      value == null ||
      typeof value !== 'object' ||
      typeof (value as { _getAllFields?: unknown })._getAllFields !== 'function'
    ) {
      return undefined
    }
    const fields = (value as { _getAllFields: () => Record<string, unknown> })._getAllFields()
    if (!fields || typeof fields !== 'object') return undefined
    return { fields: { ...fields } }
  }

  const direct = snapshotUniData(data)
  if (direct) return direct
  if (data == null || typeof data !== 'object') return data
  const record = data as { selectedData?: unknown; selected?: unknown }
  const selected = record.selectedData ?? record.selected
  if (selected !== undefined) {
    return snapshotUniData(selected) ?? selected
  }
  return data
}
